export class FiseConsultasUser {

  loginUsuario: string;
  tipoUsuario: string;

}